import { jsx as t, jsxs as h } from "react/jsx-runtime";
import { LabeledField as tn } from "./index.es494.js";
import s from "classnames";
import x from "lodash/noop";
import { forwardRef as rn, useState as on, useCallback as y } from "react";
import n from "./index.es724.js";
import { useInterval as sn } from "./index.es725.js";
import { ColorIndicator as cn } from "./index.es26.js";
import { BodyText as L } from "./index.es487.js";
import { UtilityChevronIcon as I } from "./index.es422.js";
const an = "numeric-field", R = "dec", $ = "inc", bn = rn(
  ({
    label: _,
    required: g,
    feedback: j,
    value: e,
    minValue: c = -1 / 0,
    maxValue: a = 1 / 0,
    entityColor: M,
    step: d = 1,
    suffix: k,
    disabled: r,
    isError: D,
    size: p = "default",
    placeholder: v,
    asterix: B,
    testId: f = an,
    prefix: C,
    colorIndicator: E,
    isRestingToMaxMin: U,
    removeLeadingZeros: K,
    onlyIntegers: F,
    allowHoldClickSpinner: b = !0,
    valueAlignment: O = "center",
    infoTooltip: q,
    holdClickSpinnerDelay: A = 100,
    onChange: l = x,
    onBlur: T = x,
    ...S
  }, G) => {
    const J = s(n.root, n[`root-${p}`]), [u, m] = on(null), P = s(n.inputContainer, {
      [n["align-left"]]: O === "left",
      [n["align-left-with-prefix"]]: O === "left" && !!C
    }), Q = s(n.entity, n[`entity-${p}`]), W = s(n.suffix, n[`adornments-${p}`]), X = s(n.prefix, n[`adornments-${p}`]), Y = s(n.spinnerContainer, n[`${p}`], {
      [n.error]: D,
      [n.disabled]: r
    }), Z = s(n.button, {
      [n.buttonDisabled]: r
    }), H = s(n.buttonDown, {
      [n.buttonDisabled]: r
    }), z = (i) => {
      const o = i.target.valueAsNumber;
      l(o);
    }, V = y(
      (i) => {
        if (F)
          switch (i.key.toLowerCase()) {
            case ".":
            // avoid decimals
            case "-":
            // avoid negatives
            case "+":
            // avoid positives
            case "e":
              i.preventDefault();
              break;
          }
      },
      [F]
    ), N = y(
      (i) => {
        if (!(e === void 0 || i === null))
          if (i === $) {
            const o = e + d;
            l(o > a ? a : o);
          } else {
            const o = e - d;
            l(o < c ? c : o);
          }
      },
      [e, d, l, a, c]
    ), nn = y(() => {
      u && b && N(u);
    }, [b, u, N]);
    sn(
      nn,
      A,
      !(u && b)
    );
    const en = y(
      (i) => {
        U && (e !== null || e !== void 0) && (Number(e) > a ? l(a) : Number(e) < c && l(c)), T(i);
      },
      [U, e, T, a, c, l]
    );
    let w;
    return K ? w = e !== void 0 && Number.isFinite(e) ? (e * 1).toString() : "" : w = `${e}`, /* @__PURE__ */ t(
      tn,
      {
        label: _,
        feedback: j,
        asterix: B,
        required: g,
        disabled: r,
        isError: D,
        ref: G,
        testId: `${f}-label`,
        infoTooltip: q,
        children: /* @__PURE__ */ h("div", { className: J, "data-type": "pl-numeric-field-root", children: [
          /* @__PURE__ */ h("div", { className: P, children: [
            C && /* @__PURE__ */ t(
              "span",
              {
                className: X,
                "data-testid": `${f}-prefix`,
                "data-type": "pl-numeric-field-prefix",
                children: /* @__PURE__ */ t(L, { variant: "regular", color: r ? "disabled" : "gray", children: C })
              }
            ),
            (!!M || !!E) && /* @__PURE__ */ t(
              "span",
              {
                className: Q,
                "data-type": "pl-numeric-field-entity-indicator",
                children: /* @__PURE__ */ t(
                  cn,
                  {
                    color: E,
                    entityColor: M,
                    thickness: "regular",
                    disabled: r
                  }
                )
              }
            ),
            /* @__PURE__ */ t(
              "input",
              {
                value: w,
                type: "number",
                min: c,
                max: a,
                disabled: r,
                required: D,
                placeholder: v,
                onChange: z,
                "data-testid": f,
                step: d,
                "aria-label": "numeric-field",
                onBlur: en,
                onKeyDown: V,
                ...S
              }
            ),
            k && /* @__PURE__ */ t(
              "span",
              {
                className: W,
                "data-testid": `${f}-suffix`,
                "data-type": "pl-numeric-field-suffix",
                children: /* @__PURE__ */ t(L, { variant: "regular", color: r ? "disabled" : "gray", children: k })
              }
            )
          ] }),
          /* @__PURE__ */ h(
            "div",
            {
              className: Y,
              "data-type": "pl-numeric-field-spinner",
              children: [
                /* @__PURE__ */ t(
                  "button",
                  {
                    "aria-label": "increment-spinner",
                    className: Z,
                    onClick: () => N($),
                    onMouseDown: () => m($),
                    onMouseUp: () => m(null),
                    onMouseOut: () => m(null),
                    "data-testid": `${f}-spinner-up`,
                    disabled: r,
                    children: /* @__PURE__ */ t(I, { direction: "up" })
                  }
                ),
                /* @__PURE__ */ t(
                  "button",
                  {
                    "aria-label": "decrement-spinner",
                    className: H,
                    onClick: () => N(R),
                    onMouseDown: () => m(R),
                    onMouseOut: () => m(null),
                    onMouseUp: () => m(null),
                    "data-testid": `${f}-spinner-dec`,
                    disabled: r,
                    children: /* @__PURE__ */ t(I, { direction: "up" })
                  }
                )
              ]
            }
          )
        ] })
      }
    );
  }
);
export {
  an as NUMERIC_FIELD_DEFAULT_TESTID,
  bn as NumericField
};
//# sourceMappingURL=index.es42.js.map
